module.exports = __webpack_public_path__ + "img/default_scratch_texture.5219812b.jpg";